var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.70151 12.5489c.23437.2341.55208.3656.88333.3656s.64896-.1315.88333-.3656l4.53333-4.53333 4.5333 4.53333c.237.2208.5504.341.8742.3353.3239-.0057.6329-.1369.8619-.3659.229-.2291.3602-.538.3659-.8619.0057-.3238-.1145-.6372-.3353-.8742l-5.4167-5.41663c-.2343-.23409-.552-.36557-.8833-.36557-.33125 0-.64895.13148-.88333.36557l-5.41666 5.41663c-.23409.2344-.36557.5521-.36557.8834 0 .3312.13148.6489.36557.8833z",
    fill: "#04a0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBlue);
export default __webpack_public_path__ + "static/media/icon_arrow_blue.57bbf3568d707f8716dcd9ea95c72be0.svg";
export { ForwardRef as ReactComponent };